/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Org_DeletedInputs */



/**
* | output |
* | --- |
* | "Organization deleted — name from ledger snapshot" |
*
* @param {Partner_Admin_Commission_Org_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_org_deleted = /** @type {((inputs?: Partner_Admin_Commission_Org_DeletedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Org_DeletedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisation gelöscht — Name aus dem Ledger-Snapshot")
	return /** @type {LocalizedString} */ ("Organization deleted — name from ledger snapshot")
});